import type { ReactNode } from 'react';

/**
 * Helper function that can coerce `props.children` so that it's
 * guaranteed to be an array.
 */
export function coerceToChildrenArray<T extends ReactNode>(
  children: undefined | T | T[]
) {
  return children == null
    ? []
    : Array.isArray(children)
    ? children
    : [children];
}
